import React from "react";
import { useEmailRouting } from "@/components/admin/email/useEmailRouting";
import AdminDestinationPanel from "@/components/admin/email/AdminDestinationPanel";
import { BootstrapCard, RoutingStatusCard } from "@/components/admin/email/RoutingStatusCards";
import { AddressList, AddAddressCard } from "@/components/admin/email/AddressCards";
import { TransactionalEmail, WorkspaceSection, NoZoneNotice } from "@/components/admin/email/EmailSections";

/** Site → Email tab: Cloudflare Email Routing + Workspace mailboxes + transactional provider. */
export default function EmailTab({ site, reload }) {
  const r = useEmailRouting(site);

  if (!site.cloudflare_zone_id) {
    return (
      <div className="space-y-4">
        <NoZoneNotice />
        <TransactionalEmail site={site} reload={reload} />
        <WorkspaceSection site={site} reload={reload} />
      </div>
    );
  }
  if (r.err && !r.overview) return <div className="border border-red-500/30 bg-red-500/5 text-red-300 rounded-sm p-4 text-sm mono">{r.err}</div>;
  if (!r.overview) return <div className="text-zinc-500 text-sm font-mono">Loading email routing…</div>;

  const { overview, destInfo } = r;
  const addresses = overview.addresses || [];
  const showActive = overview.status?.enabled || addresses.length > 0;
  const adminDest = destInfo?.email || overview.admin_destination;
  const gwsInbound = site.gws_connected_at && (site.gws_inbound || "workspace") === "workspace";

  return (
    <div className="space-y-4">
      {gwsInbound && (
        <div data-testid="email-gws-inbound-note" className="border border-sky-500/30 bg-sky-500/5 text-sky-200 rounded-sm px-4 py-3 text-xs leading-relaxed">
          <b>Inbound mail for {site.domain} is handled by Google Workspace</b> (Google MX). The Cloudflare Email Routing rules below stay configured but are inert until you switch the Workspace panel to “sending-only”.
        </div>
      )}
      <AdminDestinationPanel destInfo={destInfo} adminDest={adminDest} refresh={r.refresh} setErr={r.setErr} />
      {showActive ? (
        <>
          <RoutingStatusCard site={site} overview={overview} adminDest={adminDest} busy={r.busy} onToggleCatchAll={r.toggleCatchAll} />
          <AddressList addresses={addresses} busy={r.busy} onRemove={r.remove} />
          <AddAddressCard site={site} addresses={addresses} busy={r.busy} onAdd={r.addPrefix} />
        </>
      ) : (
        <BootstrapCard busy={r.busy} disabled={!adminDest} onBootstrap={r.bootstrap} />
      )}
      {r.err && <div className="border border-red-500/30 bg-red-500/5 text-red-300 rounded-sm p-3 text-xs mono">{r.err}</div>}
      <WorkspaceSection site={site} reload={reload} />
      <TransactionalEmail site={site} reload={reload} />
    </div>
  );
}
